import React, { useEffect } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

import { HorizontalStepper } from 'components/shared/stepper_horizontal';
import styled from '@emotion/styled';
import { StepConnector, stepConnectorClasses, StepIconProps } from '@mui/material';

interface SimHorizontalStepperProps {
  activeStep: number;
  edit?: boolean;
  hasFamilyFarmersMarket?: boolean | null;
}

export const FormSimHorizontalStepper: React.FC<SimHorizontalStepperProps> = ({
  activeStep,
  edit,
  hasFamilyFarmersMarket,
}) => {
  const steps: string[] = ['SIM', 'Feiras'];

  if (hasFamilyFarmersMarket) {
    steps.push('Tipos de feira - Permanentes');
    steps.push('Tipos de feiras - Livres');
  }

  steps.push('Certificação/Identificação');



  const centralizeActiveStep = () => {
    const stepperContainer = document.getElementById('sim-stepper-container');
    const stepperSteps = stepperContainer?.querySelectorAll('.MuiStep-root');
    const activeStepElement = stepperSteps?.[activeStep - 1];

    if (
      stepperContainer instanceof HTMLElement &&
      activeStepElement instanceof HTMLElement
    ) {
      const containerWidth = stepperContainer.offsetWidth;
      const stepWidth = activeStepElement.offsetWidth;
      const offset = containerWidth / 2 - stepWidth / 2;
      stepperContainer.scrollLeft = activeStepElement.offsetLeft - offset;
    }
  };

  useEffect(() => {
    centralizeActiveStep();
  }, [activeStep]);

  const QontoConnector = styled(StepConnector)(({ theme }: any) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#2E7D32',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#2E7D32',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor:
        (theme && theme.palette && theme.palette.mode) === 'dark' ? (theme.palette.grey[800]) : '#eaeaf0',
      borderRadius: 1,
      borderTopWidth: 3,
    },
  }));

  const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
    ({ ownerState }) => ({
      alignItems: 'center',
      color: '#eaeaf0',
      display: 'flex',
      height: 22,
      ...(ownerState.active && {
        color: '#0048B6',
      }),
      '& .QontoStepIcon-completedIcon': {
        color: '#0048B6',
        zIndex: 1,
        fontSize: 18,
      },
      '& .QontoStepIcon-circle': {
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
      },
    }),
  );

  function QontoStepIcon(props: StepIconProps) {
    const { active, completed } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }}>
        {completed ? (
          <CheckCircleIcon color="success" />
        ) : !completed && !active ? (
          <CircleIcon />
        ) : (
          <RadioButtonCheckedIcon />
        )}
      </QontoStepIconRoot>
    );
  }

  return (
    <HorizontalStepper
      id="sim-stepper-container"
      steps={steps}
      activeStep={activeStep}
      edit={edit}
      containerSx={{ overflow: 'auto', overflowX: 'hidden', overflowY: 'hidden' }}
    />
  );
};
